import { motion } from "framer-motion";
import { waLink, track } from "@/data/content";

export default function WhatsAppFloat() {
  return (
    <motion.a
      data-testid="floating-whatsapp-btn"
      href={waLink("Hola CERTERO SRL, quiero cotizar un dron agrícola o un servicio.")}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => track("whatsapp_click", { origen: "flotante" })}
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2.2, duration: 0.5 }}
      className="whatsapp-float group fixed bottom-5 right-5 z-[70] flex h-14 w-14 items-center justify-center rounded-full bg-[#25d366] shadow-[0_8px_30px_rgba(37,211,102,0.35)] transition-transform duration-300 hover:scale-105 active:scale-95"
      aria-label="Escribir por WhatsApp a CERTERO SRL"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25d366]/40 motion-safe:animate-ping" aria-hidden="true" />
      <svg viewBox="0 0 24 24" className="relative h-7 w-7 text-white" fill="currentColor" aria-hidden="true">
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22c5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2Zm5.8 14.03c-.24.68-1.4 1.3-1.93 1.35-.53.05-1.03.24-2.9-.6-2.25-1-3.68-3.33-3.79-3.49-.11-.16-.9-1.25-.86-2.36.04-1.11.62-1.64.84-1.87.22-.23.48-.28.64-.28h.46c.15 0 .35-.06.54.41.2.48.67 1.65.73 1.77.06.12.1.26.02.42-.08.16-.15.26-.29.4-.14.14-.3.31-.42.42-.14.12-.29.26-.17.5.12.24.55.97 1.18 1.57.81.77 1.5 1.02 1.72 1.13.22.11.35.1.48-.06.13-.16.56-.65.71-.87.15-.22.3-.18.5-.11.2.07 1.29.61 1.51.72.22.11.37.17.42.26.05.09.05.53-.19 1.19Z" />
      </svg>
      <span className="pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap border border-hud bg-surface px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-mist opacity-0 transition-opacity duration-300 group-hover:opacity-100 md:block">
        Cotizar por WhatsApp
      </span>
    </motion.a>
  );
}
